import { createProvideInject } from '@collector/shared-ui'

export const [provideHasChangeSides, injectHasChangeSides] =
  createProvideInject<boolean>('hasChangeSides')
